<style scoped>
a::v-deep {
  text-decoration: none;
}
</style>

<template>
  <div>
    <!-- instance details card -->
    <v-card flat tile>
      <v-toolbar color="grey lighten-4" light tile flat>
        <v-toolbar-title centered class="headline font-weight-bold">
          Instance Status
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-toolbar-items>
          <!-- reboot instance DISABLED FEATURE -->
          <v-btn disabled text color="primary darken-1">
            <v-icon size="25">mdi-restart</v-icon>
            Reboot
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
    </v-card>
    <!-- code status card -->
    <v-card flat tile v-if='infra'>
      <v-card-text>
        <v-row>
          <!--  az info -->
          <v-col md="2" sm="3">
            <h4 class="title">Availability Zone</h4>
            <p class="body-1">
              {{ infra.awsInstance.Placement.AvailabilityZone}}
            </p>
          </v-col>
          <!-- instance type -->
          <v-col md="2" sm="3">
            <h4 class="title">Instance Type</h4>
              <p class="body-1">
                {{ infra.awsInstance.InstanceType }}
              </p>
          </v-col>
          <!-- instance state -->
          <v-col md="2" sm="3">
            <h4 class="title">Instance State</h4>
              <p class="body-1" text-color="green">
                {{ infra.awsInstance.State.Name }}
              </p>
          </v-col>
          <!-- instance id -->
          <v-col md="2" sm="3">
            <h4 class="title">Instance ID</h4>
              <p class="body-1" text-color="green">
                <a target="_blank" :href='generateAwsEC2Link(infra.awsInstance.InstanceId)'>
                {{ infra.awsInstance.InstanceId }}
                </a>
              </p>
          </v-col>
          <!-- ip address -->
          <v-col md="2" sm="3">
            <h4 class="title">Public IP</h4>
              <p class="body-1" text-color="green">
                {{ infra.awsInstance.PublicIpAddress }}
              </p>
          </v-col>
          <!-- load balancer -->
          <v-col md="6" sm="6">
            <h4 class="title">Load Balancer</h4>
            <p class="body-1">
              <a target="_blank" :href='generateAwsELBLink(infra.parsedTags.Alb)'>
                {{ infra.parsedTags.Alb }}
              </a>
            </p>
          </v-col>
          <!--  phd -->
          <v-col md="6" sm="6">
            <h4 class="title">AWS Health Dashboard</h4>
            <p class="body-1">
              <a target="_blank" href="https://phd.aws.amazon.com/phd/home#/">
                phd.aws.amazon.com
              </a>
            </p>
          </v-col>
        </v-row>
        
      </v-card-text>
    </v-card>
  </div>
</template>
<script>

export default {
  components: {},
  data: () => ({ isDeploying: false }),
  props: {
    client: { required: true },
    infra: { required: true },
  },
  methods: {
    generateAwsEC2Link(instanceId) {
      return 'https://console.aws.amazon.com/ec2/v2/home?region=us-east-1#Instances:v=3;search=:' + instanceId
    },
    generateAwsELBLink(elb) {
      return 'https://console.aws.amazon.com/ec2/v2/home?region=us-east-1#LoadBalancers:search=customer-instances-2-179183940.us-east-1.elb.amazonaws.com;sort=loadBalancerName=' + elb
    }
  }
};
</script>
